// extracted by mini-css-extract-plugin
export default {"icon":"src-components-Filter-next-components-SbTableColumns__icon--h1tel"};